import { createEntityItemId } from '@wix/a11y-rules';
import { bulkUpdateServices } from '@wix/ambassador-bookings-services-v2-service/http';
import { chunk as getChunks, groupBy } from 'lodash';
import { fetchServicePages } from '../new-infra-fetchers/fetch-services';
const BULK_LIMIT = 100;
export const updateServicesImageAlt = async (httpClient, errorHandler, altTextData) => {
  const {
    withErrorHandler,
    getResolvedError
  } = errorHandler;
  const entityIdsList = altTextData.map(item => item.entityId).filter(entityId => entityId !== undefined);
  try {
    const services = await fetchServicePages(httpClient, errorHandler, entityIdsList);
    const servicesMap = new Map(services.map(service => [service.id, service]));
    const allFailedElements = [];
    const chunks = getChunks(altTextData, BULK_LIMIT);
    const updatePromises = chunks.map(async chunk => {
      var _payload$services, _data$bulkActionMetad;
      const payload = buildServiceBulkUpdatePayload(chunk, servicesMap);
      if (!(payload != null && (_payload$services = payload.services) != null && _payload$services.length)) {
        return {
          success: false
        };
      }
      const {
        data
      } = await withErrorHandler(async () => httpClient.request(bulkUpdateServices(payload)), {
        errorCodesMap: {}
      });
      const success = ((_data$bulkActionMetad = data.bulkActionMetadata) == null ? void 0 : _data$bulkActionMetad.totalFailures) === 0;
      const results = data.results;
      if (!success) {
        const failedIndexes = (results ?? []).map(_ref => {
          let {
            itemMetadata
          } = _ref;
          return itemMetadata == null ? void 0 : itemMetadata.originalIndex;
        }).filter(index => index !== undefined);
        const failedElementsChunk = chunk.filter((_, index) => failedIndexes.includes(index));
        allFailedElements.push(...failedElementsChunk);
      }
      return {
        success
      };
    });
    const results = await Promise.allSettled(updatePromises);
    const overallSuccess = results.every(result => result.status === 'fulfilled');
    return {
      failedElements: allFailedElements,
      success: overallSuccess
    };
  } catch (err) {
    console.error('Error updating service image alt text', err);
    return {
      errorMessage: getResolvedError(err).message,
      success: false
    };
  }
};
const buildServiceBulkUpdatePayload = (altTextData, servicesMap) => {
  const updatedServices = [];
  const altUpdatedByServiceId = groupBy(altTextData, item => item.entityId);
  Object.entries(altUpdatedByServiceId).forEach(_ref2 => {
    var _originalCoverMedia$i, _originalMainMedia$im;
    let [serviceId, updatesForService] = _ref2;
    const service = servicesMap.get(serviceId);
    if (!service) {
      return;
    }
    const {
      media: originalMedia
    } = service;
    const {
      items: originalItems,
      mainMedia: originalMainMedia,
      coverMedia: originalCoverMedia
    } = originalMedia || {};
    const altMap = Object.fromEntries((updatesForService || []).map(_ref3 => {
      let {
        id,
        alt
      } = _ref3;
      return [id, alt];
    }));
    const updatedMedia = {
      coverMedia: originalCoverMedia != null && (_originalCoverMedia$i = originalCoverMedia.image) != null && _originalCoverMedia$i.id ? getUpdatedItem(altMap, originalCoverMedia, 'cover_media', serviceId) : originalCoverMedia,
      items: originalItems == null ? void 0 : originalItems.map((item, index) => getUpdatedItem(altMap, item, index, serviceId)),
      mainMedia: originalMainMedia != null && (_originalMainMedia$im = originalMainMedia.image) != null && _originalMainMedia$im.id ? getUpdatedItem(altMap, originalMainMedia, 'main_media', serviceId) : originalMainMedia
    };
    updatedServices.push({
      mask: ['media'],
      service: {
        id: service.id,
        media: updatedMedia,
        revision: service.revision
      }
    });
  });
  const payload = {
    returnEntity: true,
    services: updatedServices
  };
  return payload;
};
const getUpdatedItem = (altMap, originalItem, type, entityId) => {
  const originalImage = originalItem.image ?? {};
  const newAltText = originalImage.id && altMap[createEntityItemId([entityId], originalImage.id, type)];
  if (newAltText === undefined) {
    return originalItem;
  }
  const {
    altText,
    ...rest
  } = originalImage;
  return newAltText ? {
    image: {
      ...rest,
      altText: newAltText
    }
  } : {
    image: {
      ...rest
    }
  };
};
//# sourceMappingURL=update-services-alt-text.js.map